import { useDispatch } from 'react-redux';
import { Layout } from 'src/components/SimpleKeyboard';
import { 
  toggleKeyboard, 
  handleChange, 
  handleSetKeyboardLayout,
} from 'src/slices/keyboard';

interface KeyboardProps {
  handleChange: (val: string) => void;
  handleSetKeyboardLayout: (val: Layout) => void;
}

interface UseKeyboardReturn {
  toggleKeyboard: (show: boolean) => void;
  keyboardProps: KeyboardProps;
}

export const useKeyboard = (): UseKeyboardReturn => {
  const dispatch = useDispatch();

  return {
    toggleKeyboard: (show: boolean) => dispatch(toggleKeyboard(show)),
    keyboardProps: {
      handleChange: (val: string) => dispatch(handleChange(val)),
      handleSetKeyboardLayout: (val: Layout) => dispatch(handleSetKeyboardLayout(val))
    }
  };
}; 